import './App.css';
import MainPage from './MainPage';
import About from './About';
import Header from './Header';
import Admin from './Admin';
import Login from './Login';
import RequireAuth from './RequireAuth';
import Logout from './Logout';
import { Route, Routes, NavLink } from 'react-router-dom';
import NewPost from './NewPost';
import EditPost from './EditPost';
import Errors from './Errors';
import PostRead from './PostRead';
import './Navigation.css'
import Page from './Page';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const App = () => {
  return (
    <div className="App">
      <Header/>
      <Navigation />
      <div className="content">
        <Page>
        <Routes>
            <Route index element={<MainPage />} />
            <Route path="about" element={<About />} />
            <Route path="read/:_id" element={<PostRead></PostRead> } />
            <Route path="admin" element={ <RequireAuth redirectEnabled={true}><Admin /></RequireAuth>} />
            <Route path="logout" element={<RequireAuth redirectEnabled={true}><Logout /></RequireAuth>} />
            <Route path="new-post" element={<RequireAuth redirectEnabled={true}><NewPost /></RequireAuth>} />
            <Route path="edit-post/:_id" element={<RequireAuth redirectEnabled={true}><EditPost /></RequireAuth>} />
          
            <Route path="login" element={<Login />} />
          </Routes>
        </Page>
        
        <Errors/>
      </div>
    </div>
  );
}

const Navigation = () => {
  return (
    <nav>
      <NavLink to="" className={({isActive}) => "menu-button" + (!isActive ? "" : "-selected")} selected >home</NavLink>
      <NavLink to="about" className={({isActive}) => "menu-button" + (!isActive ? "" : "-selected")}>about me</NavLink>

      <RequireAuth>
        <NavLink to="admin" className={({ isActive }) => "menu-button" + (!isActive ? "" : "-selected")}>admin</NavLink>
            <NavLink to="logout" className={({ isActive }) => "menu-button" + (!isActive ? "" : "-selected")}>logout</NavLink>
      </RequireAuth>
    </nav>

  );
}

export default App;
